export const stringToEllipsis = (maxChars = 50, characters) => {
    if (characters && characters.length > maxChars) {
        return characters.substring(0,(maxChars - 3)) + '...';
    }

    return characters;
};